import {k} from '../kaplay.js'
import {makeButton} from '../components.js'
import {click} from '../music.js'

k.scene("menu", () => {
  k.add([
    k.text("[def]Replacing sugar is [/def]\n[wave]part math, part magic.[/wave] \n\n[def]Can you balance sweetness, taste, and sugar weight and launch a successful product?[/def]", {
      width: 500,
      align: "center",
      size: 30,
      lineSpacing: 10,
      styles: {
        "def": {
          color: k.BLACK
        },
        "wave": (idx, ch) => ({
          color: k.Color.fromHex("#E6620F"),
          pos: k.vec2(0, k.wave(-2, 2, k.time() * 4 + idx * 0.3)),
          font: "bold"
        })
      }
    }),
    k.anchor("top"),
    k.pos(k.width()/2, 280)
  ])

  const playBtn = makeButton("PLAY", k.vec2(k.width()/2, k.height()/2 + 200))

  playBtn.onClick(() => {
    k.go("game")
    click.play()
  })

  k.onDraw(() => {
    k.drawRect({
      width: k.width(),
      height: k.height(),
      color: k.Color.fromHex("#FFF3DE")
    })

    k.drawSprite({
      sprite: "logo",
      pos: k.vec2(10,10)
    })

    k.drawSprite({
      sprite: "table",
      anchor: "top",
      pos: k.vec2(k.width()/2,k.height()/2 + 320)
    })
    
    k.drawSprite({
      sprite: "bottle_shadow",
      anchor: "bot",
      pos: k.vec2(k.width()-80, k.height()/2 + 320),
      color: k.Color.fromHex("#FFD5C0"),
      opacity: 0.5
    })

    k.drawSprite({
      sprite: "bottle_shadow",
      anchor: "bot",
      height: 250,
      pos: k.vec2(k.width(), k.height()/2 + 320)
    })

    k.drawSprite({
      sprite: "bottle_shadow",
      anchor: "bot",
      pos: k.vec2(0, k.height()/2 + 320),
      height: 300,
      color: k.Color.fromHex("#FFD5C0"),
      opacity: 0.5
    })

    k.drawSprite({
      sprite: "bottle_shadow",
      anchor: "bot",
      pos: k.vec2(150, k.height()/2 + 320)
    })

    k.drawSprite({
      sprite: "title",
      anchor: "center",
      pos: k.vec2(k.width()/2, 150)
    })
  })

})
